import React from 'react'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import classNames from 'classnames'
import { isNonNullable } from '@/typeguards/common'
import { LandingAnimation } from '../LandingAnimation'
import { LANDING_ANIMATION } from '../LandingAnimation/constants'
import { LandingCardWithIcon } from '../LandingCardWithIcon'
import { ELandingDetailsAnimationDelay } from './constants'
import type { TLandingDetailsProps } from './types'
import './styles.scss'

export const LandingDetails: React.FC<TLandingDetailsProps> = ({ className, details, withAnimation }) => {
  return (
    <section className={classNames('landingDetails', className)}>
      <LandingAnimation
        desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: ELandingDetailsAnimationDelay.WHOLE_BLOCK }}
        isDisabled={!withAnimation}
      >
        {}
        <ul className="landingDetails__list page-wrapper">
          {details.map(({ icon, label, value, subValue }) => (
            <li key={label}>
              <LandingCardWithIcon className="landingDetails__detail" icon={icon} iconSize={EIconSize.L}>
                <div className="landingDetails__label">{label}</div>
                <div className="landingDetails__value h4">{value}</div>
                {isNonNullable(subValue) && <div className="text_small">{subValue}</div>}
              </LandingCardWithIcon>
            </li>
          ))}
        </ul>
      </LandingAnimation>
    </section>
  )
}
